import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../components/UI';
import { getReferredLink } from './Utils';

interface PropTypes {
  referralCode: string;
}

const TwitterTweetButton: React.FC<PropTypes> = ({ referralCode }) => {
  const { t } = useTranslation();

  const link = getReferredLink(referralCode);

  return (
    <a
      href={`https://twitter.com/share?url=${link}&text=${t('signUp.referral', {
        referralCode,
      })}`}
      target="_blank"
    >
      <Button type="button" variant="secondary" buttonClass="w-28">
        {t('referral.shareOnTwitter')}
        <img
          className="flex w-4 h-4 ml-1 cursor-pointer"
          src={`/icons/social-icons/twitter-LIGHT.svg`}
          alt={t('referral.shareOnTwitter')}
        />
      </Button>
    </a>
  );
};

export default TwitterTweetButton;
